/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Butunterlageneltern4Inputs */

const de__field_butunterlageneltern4 = /** @type {(inputs: _Field_Butunterlageneltern4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BuT-Unterlagen Eltern`)
};

/**

* @param {_Field_Butunterlageneltern4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_butunterlageneltern4 = /** @type {((inputs?: _Field_Butunterlageneltern4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Butunterlageneltern4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_butunterlageneltern4(inputs)
});
export { _field_butunterlageneltern4 as "_field_BuTUnterlagenEltern" }